import { Enum } from "../enum";


export enum PrimitiveType
{
    Boolean = "boolean",
    Number = "number",
    String = "string",
}


export type Primitive = number | string | boolean;

export namespace Primitive
{
    export function isPrimitive(value: unknown): value is Primitive
    {
        return Enum.isEnum(PrimitiveType, typeof value);
    }
}


export type PrimitiveRef = typeof Number | typeof String | typeof Boolean;

export namespace PrimitiveRef
{
    export function getFor(value: unknown): PrimitiveRef | undefined
    {
        const type = typeof value;
        if (Enum.isEnum(PrimitiveType, type))
            return typeRefsByType[type];
    }

    export function isPrimitiveRef(value: unknown): value is PrimitiveRef
    {
        return (typeof value == "function") && value === typeRefsByName[value.name];
    }


    const typeRefsByName =
    {
        [Boolean.name]: Boolean,
        [Number.name]: Number,
        [String.name]: String
    };

    const typeRefsByType: Record<PrimitiveType, PrimitiveRef> =
    {
        [PrimitiveType.Boolean]: Boolean,
        [PrimitiveType.Number]: Number,
        [PrimitiveType.String]: String,
    };
}


export type PrimitiveRefFor<T> =
    T extends number ? typeof Number :
    T extends string ? typeof String :
    T extends boolean ? typeof Boolean :
    never;


export const isPrimitive = Primitive.isPrimitive;
